"use client";

import Link from 'next/link';
import Image from 'next/image';
import { useState } from 'react';
import type { FC } from 'react';
import { usePathname } from 'next/navigation';
import { Menu, X } from 'lucide-react'; // Icons for the mobile menu

const HeaderBefore: FC = () => {
  const pathname = usePathname();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const closeMenu = () => setIsMenuOpen(false);

  return (
    <header className="sticky top-0 z-50 bg-white shadow-sm">
      <div className="container mx-auto px-4 sm:px-6 md:px-30 py-4 md:py-6 flex justify-between items-center">

        {/* Logo */}
        <div>
          <Link
            // incomplete scroll to top fix
            href="/#dash-top"
            onClick={(e) => {
              if (pathname === '/') {
                e.preventDefault();
                const element = document.getElementById('dash-top');
                if (element) {
                  element.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                  });
                }
              }
            }}
          >
            <Image
              src="/sdemarketplaceLogo2.png"
              alt="SDeMARKETPLACE Logo"
              width={180}
              height={40}
              className="h-12 w-auto"
            />
          </Link>
        </div>

        {/* Desktop Navigation (hidden on mobile) */}
        <nav className="hidden md:flex space-x-8 text-base">
          <Link href="/support" className={`hover:text-indigo-700 hover:font-medium ${pathname === '/support' ? 'text-indigo-700 font-medium' : 'text-gray-600'}`}>
            Support
          </Link>
          <Link href="/aboutus" className={`hover:text-indigo-700 hover:font-medium ${pathname === '/aboutus' ? 'text-indigo-700 font-medium' : 'text-gray-600'}`}>
            About Us
          </Link>
        </nav>

        {/* Desktop Login Button (hidden on mobile) */}
        <div className="hidden md:flex items-center">
          <Link
            href="/login"
            className="bg-indigo-600 text-white px-6 py-3 rounded-md hover:bg-indigo-700 text-base"
          >
            Login/Register
          </Link>
        </div>

        {/* Mobile Menu Button (only visible on mobile) */}
        <div className="md:hidden flex items-center">
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
            className="text-gray-600 hover:text-indigo-700"
          >
            {isMenuOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu Dropdown */}
      {isMenuOpen && (
        <div className="md:hidden bg-white shadow-sm absolute top-full left-0 w-full">
          <nav className="flex flex-col items-start space-y-5 py-5 px-8">
            <Link href="/support" className={`text-sm hover:text-indigo-700 hover:font-medium ${pathname === '/support' ? 'text-indigo-700 font-medium' : 'text-gray-600'}`} onClick={closeMenu}>
              Support
            </Link>
            <Link href="/aboutus" className={`text-sm hover:text-indigo-700 hover:font-medium ${pathname === '/aboutus' ? 'text-indigo-700 font-medium' : 'text-gray-600'}`} onClick={closeMenu}>
              About Us
            </Link>

            {/* Divider */}
            <div className="w-full border-t border-gray-200"></div>

            <div className="w-full flex justify-center">
              <Link
                href="/login"
                className="bg-indigo-600 text-white w-full text-center px-6 py-2.5 rounded-md hover:bg-indigo-700 text-sm"
                onClick={closeMenu}
              >
                Login/Register
              </Link>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
};

export default HeaderBefore;